import { Eye, Clock, Gamepad2, Film } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ContentCard = ({ content, onClick }) => {
  const thumbnailUrl = content.thumbnail_url?.startsWith('/') 
    ? `${BACKEND_URL}${content.thumbnail_url}`
    : content.thumbnail_url || 'https://placehold.co/300x200/1a1a1a/cc0000?text=LOADING';

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now - date;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    
    if (hours < 1) return 'Just now';
    if (hours < 24) return `${hours}h ago`;
    if (hours < 48) return 'Yesterday';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const getRatingColor = (rating) => {
    if (rating >= 4) return 'text-[#44ff44]';
    if (rating >= 3) return 'text-[#ffcc00]';
    if (rating >= 2) return 'text-[#ff9900]';
    return 'text-[#ff0000]';
  };

  return (
    <div 
      className="ws-content-card cursor-pointer group"
      onClick={onClick}
      data-testid={`content-card-${content.content_id}`}
    >
      {/* Thumbnail */}
      <div className="aspect-[4/3] relative overflow-hidden">
        <img 
          src={thumbnailUrl}
          alt={content.title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        
        {/* Type indicator */}
        <div className="absolute top-2 left-2 p-1 bg-black/80 border border-[#333]">
          {content.content_type === 'game' ? (
            <Gamepad2 size={12} className="text-[#cc0000]" />
          ) : (
            <Film size={12} className="text-[#cc0000]" />
          )}
        </div>

        {/* Under judgment badge */}
        {content.is_under_judgment && (
          <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-[#cc0000] text-white text-[9px] font-bold uppercase pulse-red">
            VORTEX
          </div>
        )}

        {/* Hover overlay */}
        <div className="ws-card-overlay">
          <h3 className="text-sm font-bold text-white line-clamp-2 mb-1">
            {content.title}
          </h3>
          <p className="text-[10px] text-[#999] line-clamp-1">
            by {content.author_name}
          </p>
        </div>
      </div>

      {/* Info bar */}
      <div className="p-2 bg-[#0a0a0a] border-t border-[#222]">
        <div className="flex items-center justify-between text-[10px]">
          {/* Rating */}
          <div className={`mono font-bold ${getRatingColor(content.average_rating)}`}>
            {content.average_rating?.toFixed(2) || '0.00'}
          </div>

          {/* Stats */}
          <div className="flex items-center gap-2 text-[#666]">
            <div className="flex items-center gap-0.5">
              <Eye size={10} />
              <span>{content.view_count || 0}</span>
            </div>
            <div className="flex items-center gap-0.5">
              <Clock size={10} />
              <span>{formatDate(content.created_at)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ContentCardSkeleton = () => (
  <div className="ws-content-card animate-pulse">
    <div className="aspect-[4/3] bg-[#1a1a1a]" />
    <div className="p-2 bg-[#0a0a0a] border-t border-[#222]">
      <div className="flex items-center justify-between">
        <div className="w-8 h-3 bg-[#222]" />
        <div className="w-16 h-3 bg-[#222]" />
      </div>
    </div>
  </div>
);
